import { render, staticRenderFns } from "./processApproval.vue?vue&type=template&id=c6c835ae&scoped=true"
import script from "./processApproval.vue?vue&type=script&lang=js"
export * from "./processApproval.vue?vue&type=script&lang=js"
import style0 from "./processApproval.vue?vue&type=style&index=0&id=c6c835ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6c835ae",
  null
  
)

export default component.exports